export type TableFilterOptions<T extends Record<string, unknown>> = {
  multiValueKeys?: (keyof T & string)[];
};

/** Maps Ant Design table filter payloads into flat filter state. */
export function tableFiltersToFilterValues<T extends Record<string, unknown>>(
  event: Record<string, unknown>,
  options?: TableFilterOptions<T>
): Partial<T> {
  const multiKeys = new Set(options?.multiValueKeys ?? []);
  const output: Partial<T> = {};

  for (const key in event) {
    const value = event[key];
    if (Array.isArray(value)) {
      if (multiKeys.has(key as keyof T & string)) {
        output[key as keyof T] = (value as string[]).join(',') as T[keyof T];
      } else {
        output[key as keyof T] = (value.length > 0 ? value[0] : '') as T[keyof T];
      }
    } else if (value !== null && value !== undefined) {
      output[key as keyof T] = value as T[keyof T];
    } else {
      output[key as keyof T] = '' as T[keyof T];
    }
  }

  return output;
}
